import * as React from "react";
import { questTaskComponentMap } from "./tasks/questTaskComponentMap";
export var QuestItemTask = function (_a) {
    var questInfoTaskMap = _a.questInfoTaskMap, quest = _a.quest;
    var tasks = Object.keys(quest.tasks || {}).map(function (key) {
        var task = quest.tasks[key];
        var questInfoTasks = questInfoTaskMap.get(quest.id);
        if (task != undefined && questInfoTasks != undefined) {
            var Component = questTaskComponentMap.get(key);
            return (React.createElement(Component, { className: "quest-item__bottom", key: key, tasks: task, quest: quest, questInfoTasks: questInfoTaskMap.get(quest.id) }));
        }
        return React.createElement(React.Fragment, null);
    });
    return React.createElement(React.Fragment, null, tasks);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/QuestItemTask.tsx
// module id = 2664
// module chunks = 3